export default "__VITE_ASSET__CoR9VBwt__"